import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { useLocaleText, WrapperVariantContext, } from "@mui/x-date-pickers/internals";
import { Button, DialogActions } from "@mui/material";
/**
 *
 * @param {PickersActionBarProps} props Component props
 * @returns {ReactElement | null} CustomActionBar
 */
function CustomActionBar(props) {
    const { onAccept, onClear, onCancel, onSetToday, actions } = props;
    const wrapperVariant = useContext(WrapperVariantContext);
    const localeText = useLocaleText();
    const actionsArray = typeof actions === "function" ? actions(wrapperVariant) : actions;
    if (actionsArray == null || actionsArray.length === 0) {
        return null;
    }
    const buttonActions = actionsArray?.map((actionType) => {
        switch (actionType) {
            case "clear":
                return (_jsx(Button, { onClick: () => {
                        onClear();
                    }, children: localeText.clearButtonLabel }, actionType));
            case "cancel":
                return (_jsx(Button, { onClick: () => {
                        onCancel();
                    }, children: localeText.cancelButtonLabel }, actionType));
            case "accept":
                return (_jsx(Button, { onClick: () => {
                        onAccept();
                    }, children: localeText.okButtonLabel }, actionType));
            case "today":
                return (_jsx(Button, { onClick: () => {
                        onSetToday();
                    }, children: localeText.todayButtonLabel }, actionType));
            default:
                return null;
        }
    });
    return _jsx(DialogActions, { children: buttonActions });
}
export { CustomActionBar };
